import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_UEBERSICHT_EXCEL = '[QschecksModul] GetUebersichtExcel laden';
export const GET_UEBERSICHT_EXCEL_AUSFUEHREN = '[QschecksModul] GetUebersichtExcel ausführen';
export const GET_UEBERSICHT_EXCEL_ERFOLGREICH = '[QschecksModul] GetUebersichtExcel laden erfolgreich';
export const GET_UEBERSICHT_EXCEL_FEHLER = '[QschecksModul] GetUebersichtExcel Ladefehler';
export const GET_UEBERSICHT_EXCEL_NICHT_AUSGEFUEHRT = '[QschecksModul] GetUebersichtExcel nicht ausgeführt (evtl. Offline)';


export class GetUebersichtExcelAction implements Action {
    readonly type = GET_UEBERSICHT_EXCEL;
        constructor(public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtExcelAusfuehrenAction implements Action {
    readonly type = GET_UEBERSICHT_EXCEL_AUSFUEHREN;
        constructor(public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtExcelErfolgreichAction implements Action {
    readonly type = GET_UEBERSICHT_EXCEL_ERFOLGREICH;
        constructor(public payload: string, public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtExcelFehlerAction implements Action {
    readonly type = GET_UEBERSICHT_EXCEL_FEHLER;
        constructor(public payload: any, public uebersichtRequest: api.UebersichtRequest, public optPayload: any = null) {}
    }
export class GetUebersichtExcelNichtAusgefuehrtAction implements Action {
    readonly type = GET_UEBERSICHT_EXCEL_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksCommandUebersichtExcelActions =
    GetUebersichtExcelAction
    | GetUebersichtExcelAusfuehrenAction
    | GetUebersichtExcelErfolgreichAction
    | GetUebersichtExcelFehlerAction
    | GetUebersichtExcelNichtAusgefuehrtAction
    ;
